import { AppDispatcher } from './app.dispatcher';
import { BrowserManagerDispatcher } from './browser-manager.dispatcher';

export const dispatchers = [AppDispatcher, BrowserManagerDispatcher];

export { AppDispatcher, BrowserManagerDispatcher };
